import App from 'app/app.js';

function LtFormatToHtmlFilter($sce) {
  return function (val) {
    return $sce.trustAsHtml(val);
  };
}

App.filter('ltFormatToHtmlFilter', ['$sce', LtFormatToHtmlFilter]);
